require('./bootstrap');
import './axios-config';

import { createApp, ref } from "vue";
import i18n from './i18n'
import App from './App.vue'
import store from "./store"
import router from './router'
import moment from 'moment'
import VueCookies from 'vue-cookies'

import VueAxios from 'vue-axios'
import axios from 'axios'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'


import Toaster from "@meforma/vue-toaster"
import LaravelPermissionToVueJS from 'laravel-permission-to-vuejs'

import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import BugsnagPerformance from '@bugsnag/browser-performance'

Bugsnag.start({
    apiKey: '050da78e7ca7f80a5059281f2fd40977',
    plugins: [new BugsnagPluginVue()],
    onError: function (event) {
        // Add more context for i18n errors
        if (event.errors[0].errorClass === 'SyntaxError' &&
            event.errors[0].stacktrace[0].file?.includes('message-compiler')) {
            event.addMetadata('i18n', {
                locale: i18n.global.locale,
                currentRoute: window.location.pathname
            })
        }
    }
})
BugsnagPerformance.start({ apiKey: '050da78e7ca7f80a5059281f2fd40977' })


store.dispatch("auth/getUser").then((res) => {
    store.dispatch("sesiunetaxe/fetchCurrentSession");

    const bugsnagVue = Bugsnag.getPlugin('vue')

    const app = createApp(App);


    if (bugsnagVue) {
        app.use(bugsnagVue)
    }


    app.use(VueAxios, axios)


    app.config.globalProperties.$axios = axios

    app.use(LaravelPermissionToVueJS)
    app.use(i18n)
    app.use(router)
    app.use(store)
    app.use(VueSweetalert2)
    app.use(VueCookies);
    app.use(Toaster, {
        position: "top-right"
    })

    /**
     * @params {date} date to be converted to timeago
     * @returns returns timeAgo
     */
    app.config.globalProperties.$filters = {
        timeAgo(date) {
            return moment(date).fromNow()
        },
        sDate(date) {
            return moment(date).format('LL')
        },
        pluralize(amount, word, words) {
            return (amount > 1 || amount === 0) ? words : word
        }
    }
    app.mount('#app')


});
